import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Apply from './pages/Apply';
import OrderForm from './pages/OrderForm';
import Contact from './pages/Contact';
import Dashboard from './pages/Dashboard';
import AuthCallback from './pages/AuthCallback';
import MyOrders from './pages/MyOrders';
import Legal from './pages/Legal';
import Footer from './components/Footer';
import NotFound from './pages/NotFound';
import { api } from './api';

const DEV = process.env.REACT_APP_DEV_MODE === 'true';

export default function App() {
  const [ready, setReady] = useState(!DEV);

  useEffect(() => {
    if (!DEV) return;
    if (localStorage.getItem('bce_token')) { setReady(true); return; }
    api.get('/auth/dev-login')
      .then(r => { localStorage.setItem('bce_token', r.data.token); setReady(true); })
      .catch(() => setReady(true));
  }, []);

  if (!ready) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#080808' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, color: '#F5A800', fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '0.15em', textTransform: 'uppercase', fontSize: 13 }}>
        <div className="bce-spinner" />
        Dev Mode Loading...
      </div>
    </div>
  );

  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/"              element={<Home />} />
        <Route path="/about"         element={<About />} />
        <Route path="/apply"         element={<Apply />} />
        <Route path="/order"         element={<OrderForm />} />
        <Route path="/contact"       element={<Contact />} />
        <Route path="/privacy"       element={<Legal type="privacy" />} />
        <Route path="/terms"         element={<Legal type="terms" />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/dashboard"     element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/my-orders"     element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
        <Route path="*"              element={<NotFound />} />
      </Routes>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#0e0e0e',
            border: '1px solid rgba(245,168,0,0.25)',
            color: '#F2F2F2',
            fontFamily: "'DM Sans', sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}
